module.exports = __webpack_public_path__ + "static/media/droplet.dbad8fb9.mp4";